import type { OverviewDashboardData } from './types';

function escapeCsv(value: string | number): string {
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function exportOverviewDashboardCsv(data: OverviewDashboardData, filenamePrefix = 'overview-dashboard') {
  const lines: string[] = [];

  lines.push('Overview Dashboard Export');
  lines.push(`Period,${escapeCsv(data.dateRangeLabel)}`);
  lines.push('');

  lines.push('KPI Summary');
  lines.push('Metric,Value,Trend');
  data.kpiCards.forEach((k) => {
    lines.push([k.title, k.value, k.trend].map(escapeCsv).join(','));
  });
  lines.push('');

  lines.push('Daily Labour Cost');
  lines.push('Date,Planned,Actual');
  data.labourCostChart.forEach((d) => {
    lines.push([d.dateLabel, d.planned, d.actual].map(escapeCsv).join(','));
  });
  lines.push('');

  lines.push('Labour Cost by Location');
  lines.push('Location,Amount,Percent');
  data.locationCosts.forEach((l) => {
    lines.push([l.name, l.value, `${l.percent}%`].map(escapeCsv).join(','));
  });
  lines.push('');

  lines.push('Labour Cost by Department');
  lines.push('Department,Amount,Percent');
  data.departmentCosts.forEach((d) => {
    lines.push([d.name, d.value, `${d.percent}%`].map(escapeCsv).join(','));
  });
  lines.push('');

  lines.push('Employee Spotlight');
  lines.push('Employee,Role,Attendance %,Late,Early Leave,Overtime,Labour Cost');
  data.employeeSpotlight.forEach((e) => {
    lines.push(
      [e.name, e.role, e.attendance, e.late, e.earlyLeave, e.overtime, e.labourCost].map(escapeCsv).join(','),
    );
  });

  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filenamePrefix}-${new Date().toISOString().slice(0, 10)}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
